export default __webpack_public_path__ + "static/media/chevron.959a7da6.svg";